import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, FormControl } from "@angular/forms";
import { HelperService} from '../helper.service';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  registerForm:FormGroup
  isSubmitted = false;
  userEmail:string;
  password:string;
  confPassword:string;
  firstName:string;
  lastName:string;
  phone:string;
  hostID:string;
  token_data:string;
  userID:string;
  verifiedStatus:string;
  userList:any;
  email:string;  
  agree=false;
  newsLetter = true;
  errormsg:string;
  imageThumb = '';
  selectedFile: File = null;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService) {

      this.registerForm = this.formBuilder.group({
        image: [''],
        userEmail: ['', [Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        password:  ['', [Validators.required, Validators.minLength(6)]],
        confPassword:['',Validators.required],
        firstName:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$'), Validators.pattern(/^\S/)]],
        lastName:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$'), Validators.pattern(/^\S/)]],
        phone:['',[Validators.required,Validators.pattern(/^\d{10,11}$/)]],
        agree:[false, Validators.requiredTrue],
        newsLetter:['']
      },
      {
        validator:this.MustMatch('password', 'confPassword')
       }

      );

     }

  ngOnInit() {
  }

  get f(){
    return this.registerForm.controls;
  }

  checkField(field) {
    const formField = this.registerForm.controls[field];

    return formField.invalid && (formField.touched || this.isSubmitted);
  }

   MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
           
            return;
            
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
           
        } else {
            matchingControl.setErrors(null);
        }
    }
}

getImageThumb1() {

  const value = this.registerForm.controls['image'].value;

  if (value === '') {
    return this.imageThumb;
  } 
  else
    return this.imageThumb;
}

onFileSelected(event) {

  if (event.target.files && event.target.files.length > 0) {
    let reader = new FileReader();
    this.selectedFile = <File>event.target.files[0];
    this.registerForm.controls['image'].patchValue(this.selectedFile.name);
    reader.readAsDataURL(this.selectedFile);
    reader.onload = (e: any) => {
      this.imageThumb = e.target.result;
      
    }
  };
}



  signup(){   

    

    if (!this.registerForm.controls['agree'].value) {
      alert("Please Enter Terms and condition");
      return;
      }
    
    if (this.registerForm.invalid) {
      return;
    }
    

    
    else {

      let registerData = {

        "image":this.registerForm.controls['image'].value,"firstName":this.firstName,
        "lastName":this.lastName,"phoneNumber":this.phone,
        "code":"","userEmail":this.userEmail,
        "password":this.password,"confirmPassword":this.confPassword,"newsLetter":true,
        "terms":this.agree,"userTypeID":1
        
      }

      this.apiService.signUp(registerData).subscribe(async (res: any) => {

        this.hostID = res.data.hostID;
        this.token_data = res.data.token_data;
        this.userID = res.data.userID;

        this.helperService.setToken(this.helperService.studented_btoa(this.token_data));
        this.helperService.setUserID(this.helperService.studented_btoa(this.userID));
        this.helperService.setHostID(this.helperService.studented_btoa(this.hostID));

        //localStorage.setItem("hostID", this.hostID);
        //localStorage.setItem("token_data", this.token_data);
        //localStorage.setItem("userID", this.userID);

        /*let ext = '';
      if (this.selectedFile.name.includes('jpg')) {
        ext = '.jpg';
      } else if (this.selectedFile.name.includes('png')) {
        ext = '.png';
      } else if (this.selectedFile.name.includes('jpeg')) {
        ext = '.jpeg';
      }*/

      /*let userCredential = {
        token: localStorage.getItem("token_data"),        
        userID: localStorage.getItem("userID")
      }

        this.apiService.updateUserProPic(userCredential, this.selectedFile, ext).subscribe(
          (res: any) => {
  
            console.log(res);
          })*/
  

      

        if(this.userID){
          let userdata = {
            //token: this.helperService.studented_atob(this.helperService.getToken()),
            userID: this.helperService.studented_atob(this.helperService.getUserID()),
  
          }
          this.apiService.checkUser(userdata).subscribe(async (res: any) => {
           
            this.userID = res.data.userStatus.data.id;
            this.verifiedStatus = res.data.userStatus.data.verifiedStatus;

            let deviceData = {

              "deviceID":null,"deviceToken":null,"deviceType":null,
              //"token":this.helperService.studented_atob(this.helperService.getToken()),
              "userID":this.helperService.studented_atob(this.helperService.getUserID())              
            }
      
            this.apiService.registerDevice(deviceData).subscribe(async (res: any) => {
             
      
            }, async err => {
      
            })
      
            let userDetailsData = {
              //token: this.helperService.studented_atob(this.helperService.getToken()),
              userID: this.helperService.studented_atob(this.helperService.getUserID()),
  
            }
      
            this.apiService.userDetails(userDetailsData).subscribe((res:any)=>{
             
              this.userList = res.data.getUserData.data;
              this.email = this.userList.user.userEmail;
              
              localStorage.setItem("email",this.email);
      
              
              this.router.navigateByUrl(`otp`);
              
          },async err => {
             
          })     


  
          }, async err => {
  
          })

        }
        else {

          alert("User ID already exists");
          return;

        }


      }, async err => {
        this.errormsg = err.error.meta.msg;
        alert(this.errormsg);
        
      })      
       
           
    }


  }

  signin(){
    this.router.navigateByUrl('login');
  }

}
